import { PDFDocument } from 'pdf-lib';
import React, { useState, useEffect, useCallback } from 'react';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import FooterComponent from '../components/FooterComponent';
import LoadingComponent from '../components/LoadingComponent';
import { useHistory, useParams, Redirect, useLocation } from 'react-router';
import { Button, useMediaQuery, Snackbar } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { useRecoilState } from 'recoil';
import { isLoggedIn } from '../GlobalState';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import { getSiteContactDetails } from '../apicalls/siteContact';
import { siteContactPdf } from '../generatePdf/siteContactPdf';
import { getPdfDataToDownload } from '../apicalls/savePdf';
import { PdfIcon } from '../components/parts/svgIcon/FileIcon';
import { downloadPdf } from '../utils/downloadDocment';
import {
  downloadDocument,
  updateSendStatus
} from '../apicalls/documentExternalSharePage';

export const PreviewDownloadSitecontact: React.FC = () => {
  const [pdfURL, setPdfURL] = useState('');
  const [constructionName, setConstructionName] = useState<string>('');
  const history: any = useHistory();
  const params: any = useParams();
  const location: any = useLocation();
  const [open, setOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(true);

  const [loggedIn, setLoggedIn] = useRecoilState(isLoggedIn);
  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const [consrtuctionData, setConstructionData] = useState<any>([]);
  // const [openSelectModal, setopenSelectModal] = useState(false);
  // const [constructId, setConstructId] = useState("");

  const getTheDetailsOfSiteContacts = useCallback(() => {
    console.log('getTheDetailsOfSiteContacts', params.id);

    getSiteContactDetails(params.id).then(data => {
      console.log('getSiteContactDetails');
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          console.log('こっち');
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            console.log('そっち');
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            console.log('どっち');
            previewPdf(data.data);
            console.log('どっち1');
            setConstructionName(data.data.construction_name);
          }
        }
      }
    });
  }, [changeLoggedInData, params.id]);

  useEffect(() => {
    openPage();

    getTheDetailsOfSiteContacts();
  }, [getTheDetailsOfSiteContacts]);

  const previewPdf = async (data: any) => {
    console.log('previewPdfどっち');
    if (data.document_id) {
      console.log('previewPdf');
      let pdfDocData = await getPdfDataToDownload(data.document_id);
      const pdfDoc = await PDFDocument.load(pdfDocData.data);
      const exportPdf = await pdfDoc.save();
      const blob = await new Blob([exportPdf.buffer], {
        type: 'application/pdf'
      });
      setPdfURL(URL.createObjectURL(blob));
      setLoading(false);
    } else {
      console.log('previewPdfそっち');
      let blob = await siteContactPdf(data);
      setPdfURL(URL.createObjectURL(blob));
      setLoading(false);
    }
  };

  const matches2 = useMediaQuery('(min-width:900px)');

  const backEdit = () => {
    history.replace(location.state.backPath);
  };

  const openPage = () => {
    console.log('openPage');
    updateSendStatus().then((data: any) => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          }
        }
      }
    });
  };

  const onClickDownloadPdf = () => {
    console.log('onClickDownloadPdf', onClickDownloadPdf);
    downloadDocument(location.state.document_id).then((data: any) => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            downloadPdf(pdfURL, '現場連絡表', constructionName);
          }
        }
      }
    });
  };

  if (loggedIn === 'Not logged in!') {
    return <Redirect to='/' />;
  }

  return (
    <>
      <AppBarComponent isDocumentDownloadPage={true} />
      {loading ? (
        <>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <LoadingComponent />
        </>
      ) : (
        <div
          style={{
            overflow: 'hidden',
            backgroundColor: '#F5F5F5',
            minHeight: window.innerHeight - 120
          }}
        >
          <div style={{ margin: 15 }}>
            <div className='table-top-container-customer'>
              <Button
                style={{
                  minWidth: 90,
                  marginRight: 15,
                  color: '#758283',
                  backgroundColor: '#F5F5F5',
                  marginBottom: !matches2 ? 10 : 0
                }}
                variant='contained'
                color='secondary'
                onClick={() => backEdit()}
                startIcon={<ArrowBackIcon />}
              >
                戻る
              </Button>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                <div style={{ marginLeft: 20 }}>
                  ※ダウンロードすると送信者に通知されます。
                </div>
                <Button
                  style={{
                    minWidth: 90,
                    marginRight: 15,
                    color: '#758283',
                    backgroundColor: '#F5F5F5',
                    marginBottom: !matches2 ? 10 : 0
                  }}
                  variant='contained'
                  color='secondary'
                  onClick={() => onClickDownloadPdf()}
                >
                  <PdfIcon width={21} height={26} />
                  <div style={{ marginLeft: 8 }}>ダウンロード</div>
                </Button>
              </div>
            </div>

            <div style={{ backgroundColor: '#FFFFFF' }}>
              <div className='table-top-container-customer'>
                <iframe
                  title='preview-sitecontact'
                  src={pdfURL}
                  width='100%'
                  height='1000px'
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      )}
      <FooterComponent />
    </>
  );
};
